import * as React from "react";

export type NotificationSeverity = "success" | "error" | "info" | "warning";

export interface Notification {
  id: string;
  message: string;
  severity: NotificationSeverity;
  duration: number;
}

/**
 * @param severity Defaults to "success" if omitted.
 * @param duration Auto-dismiss delay in ms. Defaults to 3000.
 */
export type ShowNotification = (
  message: string,
  severity?: NotificationSeverity,
  duration?: number,
) => void;

export const NotificationDispatchContext =
  React.createContext<ShowNotification>(() => {});
